import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import Button from '../../../shared/components/ui/Button';
import FormInput from '../../../shared/components/ui/FormInput';
import { createApplication } from '../../services/api/implementation/impl';

const QuickApplicantModal = ({ dealId, applicantNumber, onClose, onSuccess }) => {
  const [submitting, setSubmitting] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    defaultValues: {
      name: '',
      email: '',
      mobile: '',
      pan: '',
      aadhar: '',
      address: ''
    }
  });

  const onSubmit = async (data) => {
    setSubmitting(true);
    try {
      await createApplication({
        deal_id: Number(dealId),
        applicant_number: applicantNumber,
        name: data.name,
        email: data.email,
        mobile: data.mobile,
        pan: data.pan,
        aadhar: data.aadhar,
        address: data.address,
        relationship: applicantNumber === 1 ? 'Self' : 'Co-applicant',
        gender: 'Male'
      });
      toast.success('Applicant saved');
      onSuccess?.();
    } catch (err) {
      toast.error(err?.response?.data?.message || err?.message || 'Save failed');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4 p-2">
      <p className="text-sm text-slate-600">
        Quick add for co-applicant #{applicantNumber}. For full KYC fields use the application form
        for applicants 1–2.
      </p>
      <FormInput
        label="Full name"
        register={register}
        register_key="name"
        isRequired
        errors={errors}
        validation={{ required: 'Name is required' }}
      />
      <div className="grid gap-3 sm:grid-cols-2">
        <FormInput
          label="Mobile"
          register={register}
          register_key="mobile"
          isRequired
          errors={errors}
          validation={{ required: 'Mobile is required' }}
        />
        <FormInput
          label="Email"
          register={register}
          register_key="email"
          isRequired
          errors={errors}
          validation={{ required: 'Email is required' }}
        />
      </div>
      <div className="grid gap-3 sm:grid-cols-2">
        <FormInput label="PAN" register={register} register_key="pan" errors={errors} />
        <FormInput label="Aadhaar" register={register} register_key="aadhar" errors={errors} />
      </div>
      <FormInput label="Address" register={register} register_key="address" errors={errors} />
      <div className="flex justify-end gap-2 pt-2">
        <Button type="button" displayType="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button type="submit" disabled={submitting}>
          {submitting ? 'Saving…' : 'Save applicant'}
        </Button>
      </div>
    </form>
  );
};

export default QuickApplicantModal;
